// src/components/CityFX/NeonCity.jsx
// Capas cyberpunk extra (estrellas pixel + grilla synthwave + skyline nocturno)
// para los fondos de auth. `prefix` engancha con el CSS de cada página:
//   'lg' → Login  ·  'rg' → Register
import React from 'react';
import cityImg from '../../assets/fx/city.png';
import starsImg from '../../assets/fx/stars.svg';

export default function NeonCity({ prefix }) {
  return (
    <>
      <div className={`${prefix}-stars`} style={{ '--nc-stars': `url(${starsImg})` }} aria-hidden="true" />
      <div className={`${prefix}-grid`} aria-hidden="true" />
      <div className={`${prefix}-city`} style={{ '--nc-city': `url(${cityImg})` }} aria-hidden="true" />
    </>
  );
}
